import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useNursingStore = defineStore({
    id: 'nursing',
    state: () => ({
        eggDescList: [
            {
            }
        ],
        photoDescList: [
            {
                id: 'nursingMedicalConciergeDesc1',
                label: 'nursing.nursingMedicalConciergeDesc1',
                description: '',
                image: { componentName: 'nursing', imgName: 'MC1', imgFormat: 'png' },
            },
            {
                id: 'nursingMedicalConciergeDesc2',
                label: 'nursing.nursingMedicalConciergeDesc2',
                description: '',
                image: { componentName: 'nursing', imgName: 'MC2', imgFormat: 'png' },
            },
            {
                id: 'nursingMedicalConciergeDesc3',
                label: 'nursing.nursingMedicalConciergeDesc3',
                description: '',
                image: { componentName: 'nursing', imgName: 'MC3', imgFormat: 'png' },
            },
            {
                id: 'nursingMedicalConciergeDesc4',
                label: 'nursing.nursingMedicalConciergeDesc4',
                description: '',
                image: { componentName: 'nursing', imgName: 'MC4', imgFormat: 'png' },
            },
            {
                id: 'nursingMedicalConciergeDesc5',
                label: 'nursing.nursingMedicalConciergeDesc5',
                description: '',
                image: { componentName: 'nursing', imgName: 'MC5', imgFormat: 'png' },
            },
        ]
    }),
    getters: {},
    actions: {
    },
});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useNursingStore, import.meta.hot));
}

export { useNursingStore };